export default __webpack_public_path__ + "static/media/icon_label_order_complete.ac6b54f4.png";